import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProcessingReassuranceModule } from "app_sasha/shared/components/processing-reassurance/processing-reassurance.module";
import { BookingQualityCheckResolver } from "app_sasha/pages/processing-quality-check/processing-quality-check.resolver";
import { BookingQualityCheckRouting } from "app_sasha/pages/processing-quality-check/processing-quality-check.routing";
import { ProcessingQualityCheckComponent } from "app_sasha/pages/processing-quality-check/processing-quality-check.component";
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';
import { HasSyscodesGuard } from 'app_sasha/shared/guards/has-syscodes.guard';

@NgModule({
    imports: [
        CommonModule,
        ProcessingReassuranceModule,
        BookingQualityCheckRouting,
        TitleServiceModule,
    ],
    declarations: [
        ProcessingQualityCheckComponent
    ],
    providers: [
        BookingQualityCheckResolver,
        HasSyscodesGuard,
    ]
})
export class ProcessingQualityCheckModule { }
